import React from 'react'
import Select, { StylesConfig } from "react-select";
import TextField from '../../../../core/common/textFields/TextField';
import { svgIcons } from '../../../../style/fonts/SvgIcons';

const MarketingTab = ({ isReadOnly, formik, leadsInquiryLookups, getdefaultLookups,getallActiveUsers }: any) => {
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    return (
        <div className='row' style={{height:'539px',overflow:'auto'}}>
            <div className='col-md-4'>
                <div className='card'>
                    <div className='card-body'>
                        <h5>
                            Contact Information
                        </h5>
                        <>
                            <TextField
                                label="Lead Prospect"
                                type="text"
                                {...formik.getFieldProps("recordNumber")}

                                
                                disabled
                                icon={svgIcons.LockIcon}

                            />
                        </>
                        <>
                            <TextField
                                label="Account"
                                type="text"
                                {...formik.getFieldProps("lst_Account.value")}
                                disabled
                                icon={svgIcons.LockIcon}

                            />
                        </>
                        <>
                            <TextField
                                label="Contact"
                                type="text"
                                {...formik.getFieldProps("lst_Contact.value")}
                                disabled
                                icon={svgIcons.LockIcon}

                            />
                        </>
                        <>
                            <TextField
                                label="Opportunity"
                                type="text"
                                {...formik.getFieldProps("Opportunity")}
                                disabled
                                icon={svgIcons.LockIcon}

                            />
                        </>
                        <>
                            <TextField
                                label="Engangement"
                                type="text"
                                {...formik.getFieldProps("Engagement")}
                                disabled
                                icon={svgIcons.LockIcon}

                            />
                        </>
                        <>
                            <label className='input-label'>Lead Source Code </label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={getdefaultLookups?.result?.Lst_LeadSourceCodes?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                                value={
                                    formik.values?.lst_LeadSourceCode?.id
                                        ? {
                                            value: formik.values?.lst_LeadSourceCode?.id,
                                            label: formik.values?.lst_LeadSourceCode?.value || '',
                                        }
                                        : null
                                }
                                isDisabled={isReadOnly}
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_LeadSourceCode.id', selectedOption.value);
                                    formik.setFieldValue('lst_LeadSourceCode.value', selectedOption.label);
                                }}
                            />
                        </>
                        <>
                            <label className='input-label'>Entered By </label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={getallActiveUsers?.result?.map((option: any) => ({
                                    label: option?.userName,
                                    value: option?.userId
                                }))}
                                value={
                                    formik.values?.lst_EnteredBy?.id
                                        ? {
                                            value: formik.values?.lst_EnteredBy?.id,
                                            label: formik.values?.lst_EnteredBy?.value || '',
                                        }
                                        : null
                                }
                                isDisabled={isReadOnly}
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_EnteredBy.id', selectedOption.value);
                                    formik.setFieldValue('lst_EnteredBy.value', selectedOption.label);
                                }}
                            />
                        </>
                        <>
                            <label className='input-label'>Company </label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={leadsInquiryLookups?.result?.Lst_Company?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                                value={
                                    formik.values?.lst_Company?.id
                                        ? {
                                            value: formik.values?.lst_Company?.id,
                                            label: formik.values?.lst_Company?.value || '',
                                        }
                                        : null
                                }
                                isDisabled={isReadOnly}
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_Company.id', selectedOption.value);
                                    formik.setFieldValue('lst_Company.value', selectedOption.label);
                                }}
                            />
                        </>
                        <>
                            <label className='input-label'>Sales Manager </label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={leadsInquiryLookups?.result?.Lst_SalesManager?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                                value={
                                    formik.values?.lst_SalesManager?.id
                                        ? {
                                            value: formik.values?.lst_SalesManager?.id,
                                            label: formik.values?.lst_SalesManager?.value || '',
                                        }
                                        : null
                                }
                                isDisabled={isReadOnly}
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_SalesManager.id', selectedOption.value);
                                    formik.setFieldValue('lst_SalesManager.value', selectedOption.label);
                                }}
                            />
                        </>
                        <>
                            <label className='input-label'>Sales Consultant </label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={leadsInquiryLookups?.result?.Lst_SalesConsultant?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                                value={
                                    formik.values?.lst_SalesConsultant?.id
                                        ? {
                                            value: formik.values?.lst_SalesConsultant?.id,
                                            label: formik.values?.lst_SalesConsultant?.value || '',
                                        }
                                        : null
                                }
                                isDisabled={isReadOnly}
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_SalesConsultant.id', selectedOption.value);
                                    formik.setFieldValue('lst_SalesConsultant.value', selectedOption.label);
                                }}
                            />
                        </>
                        <>
                            <label className='input-label'>Status Reason </label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={getdefaultLookups?.result?.Lst_StatusReason?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                                value={
                                    formik.values?.lst_StatusReason?.id
                                        ? {
                                            value: formik.values?.lst_StatusReason?.id,
                                            label: formik.values?.lst_StatusReason?.value || '',
                                        }
                                        : null
                                }
                                isDisabled={isReadOnly}
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_StatusReason.id', selectedOption.value);
                                    formik.setFieldValue('lst_StatusReason.value', selectedOption.label);
                                }}
                            />
                        </>
                        <>
                            <label className='input-label'>Status</label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={getdefaultLookups?.result?.Lst_Status?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                                value={
                                    formik.values?.lst_Status?.id
                                        ? {
                                            value: formik.values?.lst_Status?.id,
                                            label: formik.values?.lst_Status?.value || '',
                                        }
                                        : null
                                }
                                isDisabled={isReadOnly}
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_Status.id', selectedOption.value);
                                    formik.setFieldValue('lst_Status.value', selectedOption.label);
                                }}
                            />
                        </>
                        <>
                            <label className='input-label'>GCLID Sent </label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={leadsInquiryLookups?.result?.Lst_GclidSent?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                                value={
                                    formik.values?.lst_GclidSent?.id
                                        ? {
                                            value: formik.values?.lst_GclidSent?.id,
                                            label: formik.values?.lst_GclidSent?.value || '',
                                        }
                                        : null
                                }
                                isDisabled={isReadOnly}
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_GclidSent.id', selectedOption.value);
                                    formik.setFieldValue('lst_GclidSent.value', selectedOption.label);
                                }}
                            />
                        </>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className='card'>
                    <div className='card-body'>
                        <h5>Influencer</h5>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarketingTab